import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase, Typography, useMediaQuery, useTheme } from "@mui/material";
import WarningIcon from "@icons/myicons/warning.svg?react";

interface Props {
  alwaysShowText?: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const UpdateConnectionButton = ({
  alwaysShowText = false,
  onClick,
}: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const showText = alwaysShowText || !isMd;
  const label = t("domains.accountPreviewCard.updateRecommended");

  return (
    <ButtonBase
      onClick={onClick}
      aria-label={label}
      sx={{
        gap: "4px",
        color: theme.palette.text.warning,
        whiteSpace: "nowrap",
        alignSelf: showText ? undefined : "flex-end",
      }}
    >
      <WarningIcon width={20} height={20} color={theme.palette.icon.warning} />
      {showText && <Typography variant="caption">{label}</Typography>}
    </ButtonBase>
  );
};
